<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            optionList: options$ | async,
            disabled: disabled.$ | async,
            values: values.$ | async
        } as data"
    >
        <ng-container *ngIf="ngControl.control">
            <div
                class="bazis-select-text"
                clickOutside
                (clickOutside)="hideList()"
            >
                <span
                    class="bazis-select-text__label"
                    [class.bh-font-medium]="hasTitleMajor"
                    *ngIf="titleKey"
                >
                    {{ t(titleKey, titleParams) }}
                    <span
                        color="danger"
                        *ngIf="data.required"
                    >
                        *
                    </span>
                </span>

                <div class="bh-inline-block bh-relative">
                    <bazis-link
                        *ngIf="selectedValues$ | async as selectedValues"
                        size="regular"
                        borderStyle="dotted"
                        class="bh-font-medium"
                        (click)="toggleList()"
                    >
                        <bazis-icon
                            size="regular"
                            [name]="showList ? icons.angleUp : icons.angleDown"
                            slot="end"
                        ></bazis-icon>
                        <ng-container *ngFor="let selected of selectedValues; let i = index">
                            <ng-container *ngIf="!visibleCount || i < visibleCount">
                                <bazis-item-with-icon-value
                                    [item]="selected"
                                ></bazis-item-with-icon-value>
                                {{ i < selectedValues.length - 1 ? ',&nbsp;' : '' }}</ng-container
                            >
                        </ng-container>

                        <ng-container *ngIf="visibleCount && selectedValues.length > visibleCount">
                            <ng-container *ngIf="!allSelectedItemsShow">
                                &nbsp;+&nbsp;
                                <span
                                    (click)="allSelectedItemsShow = true; $event.preventDefault()"
                                >
                                    {{ t('title.more') }}
                                    {{ selectedValues.length - visibleCount }}
                                </span>
                            </ng-container>
                            <ng-container *ngFor="let selected of selectedValues; let i = index">
                                <ng-container *ngIf="i > visibleCount - 1 && allSelectedItemsShow">
                                    <bazis-item-with-icon-value
                                        [item]="selected"
                                    ></bazis-item-with-icon-value>
                                    {{
                                        i < selectedValues.length - 1 && i !== visibleCount - 1
                                            ? ',&nbsp;'
                                            : ''
                                    }}
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </bazis-link>

                    <ng-container *ngIf="tooltipKey">
                        <bazis-interrogation
                            [tooltipText]="t(tooltipKey, tooltipParams)"
                            [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                            [tooltipPlacement]="tooltipSettings?.placement || 'bottom-start'"
                            [icon]="icons.interrogation"
                            [type]="interrogationType"
                        ></bazis-interrogation>
                    </ng-container>

                    <div
                        class="bazis-list bazis-list_control-dd"
                        [hidden]="!showList"
                    >
                        <bazis-multiple-selection-option
                            *ngFor="let option of data.optionList"
                            [option]="option"
                            [byCheckbox]="byCheckbox"
                            [multiple]="multiple"
                            [values]="data.values"
                            (toggled)="toggleValue(option.id)"
                        ></bazis-multiple-selection-option>
                    </div>
                </div>
            </div>

            <div class="bazis-control__error">
                <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
            </div>

            <div
                *ngIf="noteKey"
                class="bazis-control__note"
            >
                {{ noteKey }}
            </div>
        </ng-container>
    </ng-container>
</ng-container>
